import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveData } from "../../../utils";
import { GetApiHeadersWithBearer, GetRequest } from "../../../network/NetworkUtils";
import { GET_MANAGE_SAVING_GOAL, SAVING_CARD_CODE } from "../../../network/URLConstants";
import ProgressBar from "../ProgressBar";
import mouse from '../../../assets/kudzu-plus-images/mouse-icon.png'


const GoalsWidget = ({savingsGoalsItems }) => {
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appConfigData = useSelector(state => state.appConfigData);


  return(<>
  {savingsGoalsItems && savingsGoalsItems.length > 0 && savingsGoalsItems.map((validate, idx)=> {
    const getGoalImg = (icon) => `${appConfigData.APP_URL}api/icons?uri=${icon}`;
    return(
        <div className="font-hanken-grotesk">
    <div className="flex mb-[40px]">
      <div className="w-[12%] flex-none ...">
        <img src={getGoalImg(validate.icon)} alt="" className="w-[44px]"/>
      </div>
      <div className="w-[88%] flex-1 ...">
        <div className="flex justify-between mb-2">
          <div  className={`${kudzuPlusTrue? "text-[#FFFFFF]": "text-[000000]"} font-hanken-grotesk text-[20px] w-[400]`}>{validate.goalName}</div>
          <div  className={`${kudzuPlusTrue? "text-[#94C3E8]": "text-[000000]"} font-hanken-grotesk text-[20px] w-[600]`}>{parseFloat(validate.amount)?.toFixed(2)}</div>
        </div>
        <div>
          <ProgressBar
            filledbgColor={'#30bc89'}
            unfilledBg={'#323B52'}
            // progress={validate.percentage}
            progress={20}
            progressBarWidth={"100%"}
            progressBarHeight={"6px"}
          />
        </div>
      </div>
    </div>
  </div>
    )
  })}
  </>)
};

export default GoalsWidget;